module.exports = __webpack_public_path__ + "static/media/virtual-tour-product.cd5f4ade.jpg";